import { Stack, Typography } from "@mui/material";
import {
  BooleanInput,
  Create,
  ListButton,
  minValue,
  number,
  NumberInput,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { useClientApps } from "@/modules/clientApps";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const AppVersionFlagCreate = () => {
  const { data: { clientAppsList } = {} } = useClientApps();

  return (
    <Create actions={<CreateActions />} redirect="list" title="Access Level">
      <SimpleForm toolbar={<CreateToolbar />}>
        <SelectInput
          label="App"
          source="clientAppId"
          validate={required()}
          choices={clientAppsList}
        />
        <Typography variant="body2" color="textSecondary">
          Semver
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          divider={<span>.</span>}
        >
          <NumberInput
            source="major"
            validate={[required(), number(), minValue(0)]}
          />
          <NumberInput
            source="minor"
            validate={[required(), number(), minValue(0)]}
          />
          <NumberInput
            source="patch"
            validate={[required(), number(), minValue(0)]}
          />
        </Stack>
        <BooleanInput label="Allow di" source="di" defaultValue={false} />
      </SimpleForm>
    </Create>
  );
};
